export const USER_SESSIONS_LIMIT_TAG_PREFIX = 'user_sessions_limit_'

export const getUserSessionsLimitTag = (limit: number) =>
  `${USER_SESSIONS_LIMIT_TAG_PREFIX}${limit}`

export const getUserSessionsLimitFromTag = (tag: string | undefined) => {
  if (!tag?.startsWith(USER_SESSIONS_LIMIT_TAG_PREFIX)) return 0

  const [_, limit] = tag.split(USER_SESSIONS_LIMIT_TAG_PREFIX)
  return limit ? parseInt(limit) : 0
}
